import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Graph from './components/Graph';
import GraphRequests from './components/GraphRequests';
import API from '../../services/API';


class AdkPartnerGraph extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            partnerValues: {},
            subid: [],
            report: [],
            graph: [],
            graphPartners: [],
            reportTotal: {},
            countries: [],
            pagesTotal: 0,
            activePage: 1,
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        this.loadPartners();

        const date = new Date().toISOString().split('T')[0];

        this.loadGraph({ day: date })
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        this.loadGraph(filters);
    }

    loadPartners() {
        API.AdkPartners.get().then(partners => {
            partners = partners.reduce((obj, { id, name }) => {
                obj[id] = name;

                return obj;
            }, {});

            this.setState({ partnerValues: partners })
        });
    }

    loadGraph(filters) {
        API.AdkReport.get('hourly', filters, 'partner/graph')
            .then(({ graph }) => this.setState({ isLoading: false, graph }));
    }


    render() {
        const { isLoading, graph } = this.state;

        const graphs = Object.keys(graph).map(partner => {
            const name = this.state.partnerValues[partner];
            return (
                <Col>
                    <h4 style={{ textAlign: 'center' }}>{name}</h4>
                    <Col lg={6}>
                        <Graph
                            data={graph[partner]}
                        />
                    </Col>
                    <Col lg={6}>
                        <GraphRequests
                            data={graph[partner]}
                        />
                    </Col>

                </Col>
            );
        });

        return (
            <Container loading={isLoading}>
                <Heading title="Adk Hourly"/>
                <Form onSubmit={this.handleSubmit} />

                {graphs}
                {/*<Graph data={this.state.graph} partners={this.state.graphPartners} partnerNames={this.state.partnerValues}/>*/}
            </Container>
        );
    }
}

export default AdkPartnerGraph;



// WEBPACK FOOTER //
// ./src/scenes/AdkPartnerGraph/index.js